import React from 'react';
import * as classes from './layout.module.scss';

/**
 * A "visual break" adding some space to a br used in a translation
 */
export const Vbr = () => <span className={classes.vbr}><br/></span>;
